import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import GenericPromises from "../../../../api/GenericPromises";
import { Menuitem } from "../../../../interfaces/Security/menu";
import { PaymentMode } from "../../../../interfaces/Sales/Catalogs/paymentModes";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import { Header } from "../../../../components/Header";
import { Button } from "@mui/material";
import { UpdatePaymentModes } from "./update";
import { usePermissions } from "../../../../hooks/usePermissions";
import { GenericDialog } from "../../../../components/Dialogs/Dialog";
import { ButtonStyled } from "../../../../theme/buttons";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";

export const ViewPaymentModes = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentModeLocal, setPaymentModeLocal] = useState<PaymentMode>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const {showSnackBar,SnackbarComponent}= useSnackBar();

  const { GetResourceByUrl } = usePermissions();


  const onDelete = () => {
    GenericDeleteResource(`/paymentmodes/${paymentModeLocal?.payment_mode_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/paymentmodes", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message,"error");
        setOpenDialog(false);
      })
  }

  useEffect(() => {
    if (location.state === null) return navigate("/paymentmodes", { state: {}, replace: true });
    GenericGetResource(`/paymentmodes/${location.state.row.payment_mode_id}`)
      .then(
        (response) => {
          setPaymentModeLocal(response.data);

          GetResourceByUrl(`/paymentmodes`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              setDataLoaded(true);
            })
            .catch((error) => {
              showSnackBar(error.message,"error");
            });
        }
      ).catch((error) => {
        showSnackBar(error.message,"error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded &&
        <>
          <Header
            title={t("paymentmodes.title-view")}
            child={
              <div className='d-flex flex-row-reverse m-1'>
                {resourceScreen?.delete === true &&
                  <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                }
                <Button variant="outlined" onClick={() => { navigate("/paymentmodes", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
              </div>
            }
          />
          {resourceScreen?.read &&
            <>
              <div>
                <UpdatePaymentModes paymentModeLocal={paymentModeLocal} isEdit={resourceScreen?.update} />
              </div>
            </>
          }
        </>
      }
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("paymentmodes.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <SnackbarComponent/>
    </>
  )
}
